import pluralize from "pluralize";
import { sprintf } from "sprintf-js";
export var countLabel = function (count, _a) {
  var zero = _a.zero,
    one = _a.one,
    n = _a.n,
    _b = _a.suffix,
    suffix = _b === void 0 ? '' : _b;
  var template = count === 0 ? zero || n : count === 1 ? one : pluralize.plural(one) || n;
  return sprintf("".concat(template).concat(suffix), count);
};